import { render, staticRenderFns } from "./foot3.vue?vue&type=template&id=10e03308&scoped=true&"
import script from "./foot3.vue?vue&type=script&lang=js&"
export * from "./foot3.vue?vue&type=script&lang=js&"
import style0 from "./foot3.vue?vue&type=style&index=0&id=10e03308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e03308",
  null
  
)

export default component.exports